import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Box, Container, Paper, Typography, Button, Alert,
} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ReplayIcon from '@mui/icons-material/Replay';
import HomeIcon from '@mui/icons-material/Home';

const REASON_MESSAGES = {
  cancelled: 'El pago fue cancelado. No se realizó ningún cargo.',
  rejected: 'El pago fue rechazado por el banco. Por favor verifica tus datos o utiliza otro medio de pago.',
  error: 'Ocurrió un error al procesar el pago. Si tienes dudas sobre un posible cargo, contacta a soporte.',
  no_token: 'No se pudo verificar la transacción. Por favor intenta nuevamente.',
  unknown: 'El proceso de pago no pudo completarse. Por favor intenta nuevamente.',
};

const PaymentError = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const reason = params.get('reason') || 'unknown';
  const message = REASON_MESSAGES[reason] || REASON_MESSAGES.unknown;

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f5f7fa', display: 'flex', alignItems: 'center' }}>
      <Container maxWidth="sm">
        <Paper sx={{ p: { xs: 3, sm: 5 }, borderRadius: 4, textAlign: 'center' }}>
          <ErrorOutlineIcon sx={{ fontSize: 72, color: 'error.main', mb: 2 }} />

          <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
            {reason === 'cancelled' ? 'Pago cancelado' : 'Pago no completado'}
          </Typography>

          <Alert severity={reason === 'cancelled' ? 'warning' : 'error'} sx={{ mb: 3, textAlign: 'left' }}>
            {message}
          </Alert>

          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Tu reserva no fue confirmada. Puedes intentarlo nuevamente o contactar a nuestro equipo para asistencia.
          </Typography>

          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button
              variant="contained"
              startIcon={<ReplayIcon />}
              onClick={() => navigate('/agendar')}
              sx={{ borderRadius: 3, px: 3 }}
            >
              Intentar nuevamente
            </Button>
            <Button
              variant="outlined"
              startIcon={<HomeIcon />}
              onClick={() => navigate('/')}
              sx={{ borderRadius: 3, px: 3 }}
            >
              Ir al inicio
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default PaymentError;
